import React from 'react';
import { usePWA, useIOSDetection } from '@/hooks/use-mobile';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const PWADebug: React.FC = () => {
  const { 
    isInstallable, 
    isInstalled, 
    showIOSInstallPrompt, 
    isIOS,
    isSafari 
  } = usePWA();
  
  const { isIOS: detectedIOS, isSafari: detectedSafari } = useIOSDetection();

  // Check various detection methods
  const userAgent = navigator.userAgent;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isInWebAppiOS = (window.navigator as Navigator & { standalone?: boolean }).standalone;
  const sessionDismissed = sessionStorage.getItem('ios-install-dismissed');

  return (
    <div className="container mx-auto p-4 space-y-4">
      <h1 className="text-2xl font-bold">PWA Debug Information</h1>
      
      <Card>
        <CardHeader>
          <CardTitle>Device Detection</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div><strong>User Agent:</strong> {userAgent}</div>
          <div><strong>Is iOS (hook):</strong> {isIOS ? 'Yes' : 'No'}</div>
          <div><strong>Is Safari (hook):</strong> {isSafari ? 'Yes' : 'No'}</div>
          <div><strong>Is iOS (direct):</strong> {detectedIOS ? 'Yes' : 'No'}</div>
          <div><strong>Is Safari (direct):</strong> {detectedSafari ? 'Yes' : 'No'}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>PWA State</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div><strong>Is Installable:</strong> {isInstallable ? 'Yes' : 'No'}</div>
          <div><strong>Is Installed:</strong> {isInstalled ? 'Yes' : 'No'}</div>
          <div><strong>Show iOS Install Prompt:</strong> {showIOSInstallPrompt ? 'Yes' : 'No'}</div>
          <div><strong>Is Standalone:</strong> {isStandalone ? 'Yes' : 'No'}</div>
          <div><strong>iOS Standalone:</strong> {isInWebAppiOS ? 'Yes' : 'No'}</div>
          <div><strong>Session Dismissed:</strong> {sessionDismissed || 'Not set'}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Manual Tests</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div><strong>iOS Regex Test:</strong> {/iphone|ipad|ipod/.test(userAgent.toLowerCase()) ? 'Yes' : 'No'}</div>
          <div><strong>Safari Regex Test:</strong> {/safari/.test(userAgent.toLowerCase()) && !/chrome|crios|fxios/.test(userAgent.toLowerCase()) ? 'Yes' : 'No'}</div>
          <div><strong>Chrome iOS Test:</strong> {/crios/.test(userAgent.toLowerCase()) ? 'Yes' : 'No'}</div>
          <div><strong>Firefox iOS Test:</strong> {/fxios/.test(userAgent.toLowerCase()) ? 'Yes' : 'No'}</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PWADebug;
